@if(lightMode()) {
<div class="action light" [class.done]="action().done && (action().type === 'all' || action().type === 'from-me')"
    [class.deadline-overdue]="isDeadlineOverdue()">
    <div class="action__left-side" style="min-height: 100%; align-items: center; display: flex;">
        <div class="action__left-side__purpose" [class]="action().done ? 'done' : 'pending'">
            {{action().purpose}}
        </div>
    </div>
    <div class="action__main">
        <div class="action__main__left-side">
            <div>
                <span class="fw-bold">Pour: </span>
                @if(action().recipient) {
                @if(action().recipient.kind === 'service') {
                Service -
                }@else if(action().recipient.kind === 'group') {
                Groupe -
                }
                <span>{{recipientName()}}</span>
                }@else {
                <span>Inconnu</span>
                }
            </div>
            <div>
                <span class="italic small">De: </span>
                @if(action().demander ) {
                <span>{{ demanderName()}}</span>

                }@else {
                <span>Inconnu</span>
                }
            </div>

            <div>
                <span class="italic small">Créée le: </span>
                <span class="italic small">{{(action().createdAt | date: 'EEE dd/MM/yyyy hh:mm') | titlecase}} </span>
                @if(action().delayedAnnouncement) {
                <small class="italic small">({{action().delayedAnnouncement}})</small>

                }
            </div>
        </div>
        <div class="action__main__right-side">
            <div class="action__main__right-side__conversation">
                @if(action().message) {
                <label for="message" class="input-label fw-bold">Message</label>
                <div class="action__main__right-side__conversation message italic" [pTooltip]="'Message'"
                    [ngStyle]="{marginBottom: action().answer ? 'none' : 'auto'}">
                    {{action().message}}
                </div>
                }
                @if(action().answer) {
                <label for="answer" class="input-label fw-bold">Réponse</label>

                <div class="action__main__right-side__conversation answer italic" [pTooltip]="'Réponse'"
                    [ngStyle]="{marginTop: action().message ? 'none' : 'auto'}">
                    {{action().answer}}
                </div>
                }
            </div>
        </div>
    </div>
    <div class="action__right-side">
        @if(action().doneAt) {
        <span class="action__right-side__done">
            <i class="bi bi-check-circle-fill"></i>
            {{(action().doneAt | date: 'EEE dd/MM/yyyy') | titlecase}}
        </span>
        }@else if(!isDeadlineOverdue() && !action().doneAt && action().deadline) {
        <span class="action__right-side__deadline fw-semibold" [pTooltip]="'Doit être traitée pour cette date'"
            [tooltipPosition]="'left'">
            <i class="bi bi-calendar2-event"></i>
            {{(action().deadline | date: 'EEE dd/MM/yyyy') | titlecase}}
        </span>
        }
        @else if(isDeadlineOverdue() && action().deadline) {
        <span class="action__right-side__overdue cursor-pointer" [pTooltip]="deadlineDetail()">
            <i class="bi bi-exclamation-circle-fill"></i>
            {{(action().deadline | date: 'EEE dd/MM/yyyy') | titlecase}}

        </span>
        }

        @if(action().processable) {
        <span>
            <i-button styleClass="blue" text="Traiter" icon="bi bi-lightning-charge-fill"
                (click)="$event.stopPropagation(); onProcess.emit(action())"></i-button>
        </span>
        }
    </div>
</div>
}@else {
<div class="action" [class.done]="action().done && (action().type === 'all' || action().type === 'from-me')"
    [class.deadline-overdue]="isDeadlineOverdue()">
    <div class="action__left-side">
        <div class="action__left-side__purpose" [class]="action().done ? 'done' : 'pending'">
            {{action().purpose}}
        </div>
        <div class="action__left-side__actors">

            <div class="action__left-side__actors__recipient">
                <span class="fw-bold">Pour: </span>
                @if(action().recipient) {
                @if(action().recipient.kind === 'service') {
                Service -
                }@else if(action().recipient.kind === 'group') {
                Groupe -
                }
                <span>{{recipientName()}}</span>
                }@else {
                <span>Inconnu</span>
                }
            </div>
            <div class="action__left-side__actors__demander">
                <span class="italic small">De: </span>
                @if(action().demander) {
                <span>{{ demanderName()}}</span>

                }@else {
                <span>Inconnu</span>
                }
            </div>
            <div class="action__left-side__actors__createdAt">
                <span class="italic small">Créée le: </span>
                <span>{{(action().createdAt | date: 'EEE dd/MM/yyyy hh:mm') | titlecase}} </span>
                @if(action().delayedAnnouncement) {
                <small class="italic">({{action().delayedAnnouncement}})</small>

                }
            </div>
        </div>
    </div>
    <div class="action__main">
        <div class="action__main__left-side">
            <div class="action__main__left-side__meeting">
                @if(action().meeting.description.length) {
                <img src="assets/img/sidebar/Seances.svg" alt="">
                <span (click)="goToMeeting(action().meeting.id)" id="meeting-title"
                    [pTooltip]="'Ouvrir la séance dans un nouvel onglet'">{{action().meeting.description}}
                    <span class="ms-2">
                        <i class="bi bi-box-arrow-up-right"></i>
                    </span>
                </span>
                }

            </div>
            <span class="action__main__left-side__subject">
                @if(action().scope === 'points' ) {
                <span>
                    <i class="bi bi-arrow-return-right"></i>
                </span>
                <span [pTooltip]="'Titre du point'" (click)="goToPoint(action().pointId)" id="point-title"
                    [pTooltip]="'Ouvrir le point dans un nouvel onglet'">
                    {{action().subject}}
                    <span class="ms-2">
                        <i class="bi bi-box-arrow-up-right"></i>
                    </span>
                </span>
                }
            </span>
        </div>
        <div class="action__main__right-side">
            <div class="action__main__right-side__conversation">
                @if(action().message) {
                <label for="message" class="input-label fw-bold">Message</label>
                <div class="action__main__right-side__conversation message italic" [pTooltip]="'Message'"
                    [ngStyle]="{marginBottom: action().answer ? 'none' : 'auto'}">
                    {{action().message}}
                </div>
                }
                @if(action().answer) {
                <label for="answer" class="input-label fw-bold">Réponse</label>

                <div class="action__main__right-side__conversation answer italic" [pTooltip]="'Réponse'"
                    [ngStyle]="{marginTop: action().message ? 'none' : 'auto'}">
                    {{action().answer}}
                </div>
                }
            </div>
        </div>
    </div>
    <div class="action__right-side">
        @if(action().doneAt) {
        <span class="action__right-side__done">
            <i class="bi bi-check-circle-fill"></i>
            {{(action().doneAt | date: 'EEE dd/MM/yyyy') | titlecase}}
        </span>
        }@else if(!isDeadlineOverdue() && !action().doneAt && action().deadline) {
        <span class="action__right-side__deadline fw-semibold" [pTooltip]="'Doit être traitée pour cette date'"
            [tooltipPosition]="'left'">
            <i class="bi bi-calendar2-event"></i>
            {{(action().deadline | date: 'EEE dd/MM/yyyy') | titlecase}}
        </span>
        }
        @else if(isDeadlineOverdue() && action().deadline) {
        <span class="action__right-side__overdue cursor-pointer" [pTooltip]="deadlineDetail()">
            <i class="bi bi-exclamation-circle-fill"></i>
            {{(action().deadline | date: 'EEE dd/MM/yyyy') | titlecase}}

        </span>
        }
        @if(action().processable) {
        <i-button styleClass="blue" text="Traiter" icon="bi bi-lightning-charge-fill"
            (click)="$event.stopPropagation(); onProcess.emit(action())"></i-button>
        }
    </div>
</div>
}